import { requestJira } from '@forge/bridge';

import { Priority } from '../pages/gadget/model';

const BASE_PRIORITY_SCHEME_ROUTE = '/rest/api/3/priorityscheme';

export const getDefaultSchemePriorities = async () => {
    const defaultSchemeResponse = (await (await requestJira(`${BASE_PRIORITY_SCHEME_ROUTE}?onlyDefault=true`)).json()) as {
        values: { id: string }[];
    };
    const defaultSchemeId = defaultSchemeResponse.values[0].id;

    const prioritiesResponse = (await (
        await requestJira(`${BASE_PRIORITY_SCHEME_ROUTE}/${defaultSchemeId}/priorities?maxResults=10000`)
    ).json()) as {
        values: Priority[];
    };

    return prioritiesResponse.values.sort((a, b) => parseInt(a.sequence) - parseInt(b.sequence)).map(priority => priority.name);
};
